import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AuctionCard } from "@/components/AuctionCard";
import { AuthModal } from "@/components/AuthModal";
import { useAuth } from "@/context/AuthContext";
import { Reveal } from "@/components/Motion";
import { LogIn, LogOut, UserRound } from "lucide-react";

export default function Auctions() {
  const [auctions, setAuctions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [authOpen, setAuthOpen] = useState(false);
  const { user, logout } = useAuth();

  const load = () => api.get("/auctions").then((r) => setAuctions(r.data)).finally(() => setLoading(false));
  useEffect(() => { load(); const t = setInterval(load, 3000); return () => clearInterval(t); }, []);

  const onUpdate = (updated) => setAuctions((prev) => prev.map((a) => a.id === updated.id ? { ...a, ...updated } : a));

  return (
    <div className="max-w-[1200px] mx-auto px-5 md:px-10 pt-36 pb-28 min-h-screen">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <Reveal>
          <span className="mono-label text-toxic">Live Bidding</span>
          <h1 className="font-display text-5xl md:text-7xl tracking-tight mt-4 mb-3">Auctions</h1>
          <p className="text-white/50 max-w-xl">Rare corals and fish, released to the highest bidder. Prices update live and we auto-bid up to your maximum. Winners pay securely online — $50 flat shipping, FREE over $450.</p>
        </Reveal>
        <div className="shrink-0">
          {user ? (
            <div className="flex items-center gap-3">
              <span className="mono-label text-white/60 flex items-center gap-2" data-testid="account-name"><UserRound size={14} /> {user.name || user.email}</span>
              <button onClick={logout} data-testid="account-logout" className="btn-pill !py-2 !px-4 flex items-center gap-2"><LogOut size={14} /> Logout</button>
            </div>
          ) : (
            <button onClick={() => setAuthOpen(true)} data-testid="auctions-signin-btn" className="btn-pill btn-solid flex items-center gap-2"><LogIn size={15} /> Sign in / register</button>
          )}
        </div>
      </div>

      <div className="mt-8 glass rounded-2xl border border-toxic/20 px-5 py-4 text-sm text-white/60" data-testid="auction-info">
        <b className="text-toxic">How bidding works:</b> You must <b className="text-white">create a free account</b> to bid. Enter your <b className="text-white">maximum</b> bid — we automatically bid the smallest amount needed to keep you in the lead, up to your max. The live price rises only as others bid against you.
      </div>

      <div className="mt-10 space-y-8">
        {loading ? (
          Array(2).fill(0).map((_, i) => <div key={i} className="h-72 rounded-2xl bg-white/5 animate-pulse" />)
        ) : auctions.length === 0 ? (
          <p className="text-white/40 font-mono py-20 text-center">No live auctions right now. Check back soon.</p>
        ) : (
          auctions.map((a, i) => <AuctionCard key={a.id} auction={a} onUpdate={onUpdate} onRequireAuth={() => setAuthOpen(true)} index={i} />)
        )}
      </div>

      <AuthModal open={authOpen} onClose={() => setAuthOpen(false)} reason="Create a free account to place bids on corals & fish." />
    </div>
  );
}
